import {PriceAndBrandSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {Flyout, PriceLegalInfoPopup} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';
import {PriceBox} from '../PriceAndBrandHorizontal/PriceBox';
import {LogPriceDifference} from '../utils/LogPriceDifference';

export interface PriceAndAddToBasketQuickViewViewProps {
  selectedSize: SelectedSize;
  addToBasketSection: React.ReactNode;
  className?: string;
}

export const PriceAndAddToBasketQuickViewView: React.FC<
  PriceAndAddToBasketQuickViewViewProps & PriceAndBrandSection
> = ({selectedSize, addToBasketSection, className, price, product}) => {
  if (!price)
    return (
      <LogPriceDifference
        product={product}
        price={price}
        selectedSize={selectedSize}
        isInMiniADPDialog={false}
      />
    );

  return (
    <>
      <LogPriceDifference
        product={product}
        price={price}
        selectedSize={selectedSize}
        isInMiniADPDialog={false}
      />
      <section className={className}>
        <PriceAndA2BWrapper>
          <StyledPriceBox
            selectedSize={selectedSize}
            productPrice={price}
            isInMiniADPDialog={false}
          />
          {addToBasketSection}
        </PriceAndA2BWrapper>
        <PriceLegalInfoPopup PriceLegalInfoLayoutComponent={Flyout} />
      </section>
    </>
  );
};

export const PriceAndA2BWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

const StyledPriceBox = styled(PriceBox)`
  flex: 1;
`;
